import axios from 'axios';

const API_V1_PREFIX = '/api/v1';
const IMSMA_HA_SYNC_TIMESTAMP_URL = `${API_V1_PREFIX}/core/imsma-ha-sync-timestamp/`;
const IMSMA_HA_RECORDS_URL = `${API_V1_PREFIX}/imsma/ha-records/`;
const IMSMA_HA_RECORDS_GEOJSON_URL = `${API_V1_PREFIX}/imsma/ha-records/geojson/`;

const asPathForCurrentBaseUrl = (path) => {
  const baseUrl = `${axios?.defaults?.baseURL || ''}`.toLowerCase();
  if (baseUrl.endsWith('/api/v1') || baseUrl.endsWith('/api/v1/')) {
    return path.replace(/^\/api\/v1/, '');
  }
  return path;
};

const isFeatureCollection = (value) =>
  Boolean(value && value.type === 'FeatureCollection' && Array.isArray(value.features));

export const getImsmaHaSyncTimestamp = (signal) =>
  axios.get(asPathForCurrentBaseUrl(IMSMA_HA_SYNC_TIMESTAMP_URL), { signal });

export const getImsmaHaRecords = ({ search = '', imsmaId = '', page, signal } = {}) => {
  const params = {
    search: search || imsmaId || undefined,
    ...(page ? { page } : {}),
  };
  return axios.get(asPathForCurrentBaseUrl(IMSMA_HA_RECORDS_URL), {
    signal,
    params,
  });
};

export const getImsmaHaRecordsGeojson = ({ pageSize = 2000, page = 1, signal } = {}) =>
  axios.get(asPathForCurrentBaseUrl(IMSMA_HA_RECORDS_GEOJSON_URL), {
    signal,
    params: {
      page_size: pageSize,
      page,
    },
  });

export const getAllImsmaHaRecordsGeojson = async ({ pageSize = 2000, signal } = {}) => {
  const aggregated = [];
  let page = 1;
  let hasNext = true;

  while (hasNext) {
    const res = await getImsmaHaRecordsGeojson({ pageSize, page, signal });
    const payload = res?.data;

    if (isFeatureCollection(payload)) {
      aggregated.push(...payload.features);
      hasNext = Boolean(payload?.next);
      page += 1;
      continue;
    }

    if (isFeatureCollection(payload?.results)) {
      aggregated.push(...payload.results.features);
      hasNext = Boolean(payload?.next);
      page += 1;
      continue;
    }

    if (Array.isArray(payload?.results)) {
      aggregated.push(...payload.results);
      hasNext = Boolean(payload?.next);
      page += 1;
      continue;
    }

    hasNext = false;
  }

  return {
    type: 'FeatureCollection',
    features: aggregated,
  };
};

export const getHAById = (id, compact = false, global_search = false, signal) => {
  let url = `/reports/ha/${id}/?compact=${compact}`;
  if (global_search) {
    url += '&global_search=true';
  }
  return axios.get(url, { signal });
};

export const getHAComments = async (id) => {
  const url = `/validations/ha/${id}`;
  const response = await axios.get(url);
  return response;
};

export const rejectHaReport = async (id, body) => {
  const url = `/validations/ha/${id}/imsma-reject/`;
  const response = await axios.patch(url, body);
  return response;
};

export const rejectEOREReport = async (id, body) => {
  const url = `/validations/eore/${id}/imsma-reject/`;
  const response = await axios.patch(url, body);
  return response;
};

export const localRejectHaReport = async (id, body) => {
  const url = `/validations/ha/${id}/local-reject/`;
  const response = await axios.patch(url, body);
  return response;
};

export const localRejectEOREReport = async (id, body) => {
  const url = `/validations/eore/${id}/local-reject/`;
  const response = await axios.patch(url, body);
  return response;
};
